import { Card, CardBody } from 'reactstrap'
import Header from './Header'
import { AgGridReact } from 'ag-grid-react'
import { useSelector } from 'react-redux'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getJobs } from 'store/Recruitment/actions'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faEye,
  faLink,
  faPencil,
  faTrash,
} from '@fortawesome/free-solid-svg-icons'
import { setAreYouSureModalData } from 'store/Recruitment/actions'
import { deleteJob } from 'store/Recruitment/actions'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { setAllJobProps } from 'store/Recruitment/actions'
import { toast } from 'react-toastify'

function JobsManagement() {
  const history = useHistory()
  const dispatch = useDispatch()

  const { jobs } = useSelector((store) => store.recruitment)

  console.log(window.location, 'leart28')

  const columns = [
    { headerName: 'No', field: 'id' },
    {
      headerName: 'Location',
      field: 'location',
      sortable: true,
      unSortIcon: true,
    },
    { headerName: 'Title', field: 'title', sortable: true, unSortIcon: true },
    {
      headerName: 'Start Date',
      field: 'start_date',
      sortable: true,
      unSortIcon: true,
      cellRenderer: (params) =>
        params.value ? moment(params.value).format('DD-MM-YYYY') : '',
    },
    {
      headerName: 'End Date',
      field: 'end_date',
      sortable: true,
      unSortIcon: true,
      cellRenderer: (params) =>
        params.value ? moment(params.value).format('DD-MM-YYYY') : '',
    },
    {
      headerName: 'Status',
      field: 'status',
      sortable: true,
      unSortIcon: true,
      cellRenderer: (params) => (
        <div className='d-flex align-items-center h-100'>
          <span
            className={`badge px-3 py-2 ${
              params.value === 'active' ? 'bg-success' : 'bg-danger'
            } text-white`}
          >
            {params.value === 'active' ? 'Active' : 'Inactive'}
          </span>
        </div>
      ),
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },
    },

    {
      headerName: 'Created At',
      field: 'created_at',
      sortable: true,
      unSortIcon: true,
      cellRenderer: (params) =>
        params.value ? moment(params.value).format('DD-MM-YYYY') : '',
    },
    {
      headerName: 'Action',
      field: 'action',
      cellRenderer: (params) => (
        <div className='d-flex align-items-center' style={{ gap: '1rem' }}>
          <FontAwesomeIcon
            size='lg'
            icon={faLink}
            title='Copy job link'
            role='button'
            className='text-dark'
            onClick={() => {
              navigator.clipboard.writeText(
                `${window.location.origin}/job/career?job=${params.data.id}`
              )
              toast.success(`Job Url has been copied to clipboard`, {
                position: toast.POSITION.TOP_CENTER,
                className: 'general-settings-toast',
                autoClose: 2500,
              })
            }}
          />
          <FontAwesomeIcon
            size='lg'
            icon={faEye}
            title='View'
            role='button'
            className='text-warning'
            onClick={() => {
              dispatch(setAllJobProps(params.data))
              history.push(`/job/details?job=${params.data.id}`)
            }}
          />
          <FontAwesomeIcon
            size='lg'
            icon={faPencil}
            title='Edit'
            role='button'
            className='text-info'
            onClick={() => {
              dispatch(setAllJobProps(params.data))
              history.push(`/job/edit?job=${params.data.id}`)
            }}
          />
          <FontAwesomeIcon
            size='lg'
            icon={faTrash}
            title='Delete'
            role='button'
            className='text-danger'
            onClick={() =>
              dispatch(
                setAreYouSureModalData({
                  show: true,
                  customFn: () => dispatch(deleteJob(params.data.id)),
                })
              )
            }
          />
        </div>
      ),
      flex: 1,
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },
    },
  ]

  const defaultColDef = {
    sortable: true,
    unSortIcon: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 100,
    resizable: true,
  }

  useEffect(() => {
    dispatch(getJobs())
  }, [dispatch])

  return (
    <>
      <Header />
      <Card>
        <CardBody>
          <div
            className='ag-theme-alpine'
            style={{ height: '600px', width: '100%' }}
          >
            <AgGridReact
              columnDefs={columns}
              rowData={jobs}
              defaultColDef={defaultColDef}
            />
          </div>
        </CardBody>
      </Card>
    </>
  )
}

export default JobsManagement
